import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { resolveImage } from "@/lib/api";

const surgeryGroups = [
  {
    title: "Cirurgias Nasais e Seios da Face",
    items: [
      "Septoplastia",
      "Turbinectomia",
      "Sinusectomia",
      "Cirurgias Endoscópicas",
      "Remoção de Pólipos Nasais",
    ],
  },
  {
    title: "Cirurgias de Adenoide e Amígdalas",
    items: [
      "Adenoidectomia",
      "Cauterização de cornetos inferiores",
      "Amigdalectomia",
      "Adenoamigdalectomia",
      "Frenotomia Lingual",
    ],
  },
  {
    title: "Cirurgia para Ronco/Apneia do Sono",
    items: ["Uvulopalatofaringoplastia"],
  },
  {
    title: "Cirurgias de Ouvido",
    items: [
      "Timpanotomia para Tubo de Ventilação",
      "Estapedectomia",
      "Timpanoplastia",
      "Mastoidectomia",
      "Implante Coclear",
    ],
  },
  {
    title: "Cirurgias de Laringe",
    items: [
      "Microcirurgia de Laringe",
      "Cirurgias a Laser para cordas vocais",
      "Cirurgias Microscópicas",
      "Remoção de Pólipos vocais e Papiloma",
      "Remoção de Tumores Benignos e Malignos",
    ],
  },
];

const Cirurgias = () => {
  return (
    <div data-testid="cirurgias-page">
      <section className="bg-gradient-to-br from-primary via-primary to-primary/85 text-primary-foreground pt-28 md:pt-32 pb-12 md:pb-16 relative overflow-hidden">
        <div className="absolute inset-0 pattern-grid opacity-30" />
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-accent blob" />
        <div className="container-pad relative">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-8 h-px bg-accent" />
            <span className="text-[11px] tracking-[0.3em] text-accent font-semibold uppercase">CENTRO CIRÚRGICO — HOSPITAL OTORRINO</span>
          </div>
          <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-tight mb-3 text-balance">Cirurgias em Otorrinolaringologia</h1>
          <p className="max-w-2xl text-primary-foreground/75 text-sm md:text-base">Procedimentos especializados para ouvido, nariz, garganta, sono e laringe.</p>
        </div>
      </section>

      <section className="container-pad py-14 md:py-16 grid lg:grid-cols-2 gap-10 items-start">
        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <div className="aspect-[4/3] rounded-3xl overflow-hidden ring-medical sticky top-28">
            <img src={resolveImage("/images/cc.jpeg")} alt="Centro cirúrgico" className="w-full h-full object-cover" />
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <h2 className="font-display text-2xl md:text-4xl text-primary mb-4 text-balance font-light">Procedimentos com <span className="text-gradient-medical font-medium">técnica e segurança</span></h2>
          <p className="text-muted-foreground leading-relaxed mb-4 text-sm">
            As cirurgias em Otorrinolaringologia abrangem uma ampla gama de procedimentos destinados ao tratamento de condições que afetam o ouvido, nariz, garganta, laringe e sono.
          </p>
          <p className="text-muted-foreground leading-relaxed mb-6 text-sm">
            Cada procedimento é cuidadosamente planejado para atender às necessidades individuais, assegurando resultados eficazes e melhor qualidade de vida.
          </p>

          <div className="space-y-4 mb-8">
            {surgeryGroups.map((group, groupIndex) => (
              <div key={group.title} className="bg-white rounded-2xl border border-border/70 p-5 shadow-sm" data-testid={`surgery-group-${groupIndex}`}>
                <h3 className="font-display text-lg md:text-xl text-primary font-semibold mb-3">{group.title}</h3>
                <ul className="grid sm:grid-cols-2 gap-2.5">
                  {group.items.map((s, i) => (
                    <li key={s} className="flex items-start gap-2.5 text-sm" data-testid={`surgery-${groupIndex}-${i}`}>
                      <div className="w-5 h-5 rounded-full bg-accent/15 text-accent flex items-center justify-center shrink-0 mt-0.5">
                        <Check className="w-3 h-3" />
                      </div>
                      <span className="text-foreground/80">{s}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <a
            href="https://cirurgiasotorrino.com.br"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center px-6 py-3 rounded-full bg-accent text-accent-foreground font-medium hover:-translate-y-0.5 transition-all text-sm"
            data-testid="cirurgias-cta"
          >
            Agendar avaliação
          </a>
        </motion.div>
      </section>
    </div>
  );
};

export default Cirurgias;
